module.exports = __webpack_public_path__ + "img/w3_cykel_dark.6fddd1e2.png";